import { ExternalLink as ExternalLinkIcon } from "react-feather"

import CustomRichText from "~/components/CustomRichText"
import Link from "~/components/Link"

import { useFootnotesContext } from "./context"

type FootnoteContentProps = {
  number: number
  linkClass?: string
}

export const FootnoteContent: React.FC<FootnoteContentProps> = ({
  linkClass,
  number,
}) => {
  const allFootnotes = useFootnotesContext()
  const footnote = allFootnotes.find((f) => f.number === number)

  if (!footnote) return null

  const { url } = footnote.link_to_ref

  return (
    <>
      {url ? (
        <Link href={url} className={linkClass} isExternal>
          <span>{footnote.ref_title}</span>
          <ExternalLinkIcon className="ml-1 inline" size={14} />
        </Link>
      ) : (
        <span>{footnote.ref_title}</span>
      )}
      <CustomRichText field={footnote.additional_info} />
    </>
  )
}
